function setPaymentOptionsStorage(paymentOptionsArray) {
  localStorage.setItem(paymentOptionsKey(),
    JSON.stringify(paymentOptionsArray))
}

function inputDivID(cashSourceId,key){
  return `payment-option-${cashSourceId}-${key}`
}

function amountInputID(cashSourceId,key){
  return `payment-option-amount-${cashSourceId}-${key}`
}

function referenceInputID(cashSourceId,key){
  return `payment-option-detail-${cashSourceId}-${key}`
}

function paymentOptionHtml(cashSourceObject) {
  const key = cashSourceObject.key
  const cashSourceId = cashSourceObject.cashSourceId
  const cashSourceName = cashSourceObject.cashSourceName
  const cashSourceAmount = cashSourceObject.cashSourceAmount
  const details = cashSourceObject.details
  const timestamp = cashSourceObject.timestamp

  return `
  <div class="form-group" id="${inputDivID(cashSourceId,key)}">
    <label class="col-xs-12" for="payment_options">${cashSourceName}</label>
    <div class="col-xs-12 mb-1">
      <input id="${amountInputID(cashSourceId,key)}"
        class="form-control add-payment-option-amount payment-option-input"
        autocomplete="off" name="payment_options[${cashSourceId}]"
        type="text" value="${cashSourceAmount}"
        data-cash-source-id="${cashSourceId}" 
        data-cash-source-name="${cashSourceName}" 
        data-details="${details}"
        data-timestamp="${timestamp}"
      >
    </div>
    <div class="col-xs-12 mb-1">
      <input id="${referenceInputID(cashSourceId,key)}"
        data-cash-source-id="${cashSourceId}" 
        data-key="${key}"
        data-timestamp="${timestamp}"
        class="form-control payment-option-details payment-option-input"
        autocomplete="off" name="payment_options[details][${cashSourceId}]"
        type="text" value="${details}"
        placeholder="Reference/Details"
      >
    </div>
    <div class="col-xs-12">
      <a class="text-danger remove-payment-option"
        style="margin-top: auto; margin-bottom: auto"
        data-cash-source-id="${cashSourceId}" href="javascript:;" data-timestamp="${timestamp}"
      >
        remove
      </a>
    </div>
  </div>
    `
}

function setInitialPaymentOptionsData(view = 'edit') {
  localStorage.removeItem(paymentOptionsKey())

  const entityId = $('#payment-options-div').data('entity-id') || 0
  const entityType = $('#payment-options-div').data('entity-type')
  console.log('INIT CS')

  $.ajax({
    type: "get",
    url: `/entity_cash_sources/${entityId}`,
    data: { entity_id: entityId, entity_type: entityType },
    headers: {
      'X-CSRF-Token': csrfToken()
    },
    dataType: "json",
    success: function (data) {
      setPaymentOptionsStorage(data)
      setPaymentOptionsInDom()
    },
    error: function (data) {
      console.log('An error occurred.');
      console.log(data);
    },
  });
}

function setPaymentOptionsInDom() {
  const paymentOptions = getPaymentOptionsStorage()

  $('#payment-options-div').empty()

  for (let count = 0; count < paymentOptions.length; count++) {
    const paymentOption = paymentOptions[count]

    $('#payment-options-div').append(
      paymentOptionHtml(
        {
          key: count,
          cashSourceId: paymentOption.cash_source_id,
          cashSourceName: paymentOption.cash_source_name,
          cashSourceAmount: paymentOption.cash_source_amount,
          details: paymentOption.details,
          timestamp: paymentOption.timestamp
        }
      )
    )

    const amountInputId = `#${amountInputID(paymentOption.cash_source_id,count)}`
    const inputDivId = `#${inputDivID(paymentOption.cash_source_id,count)}`

    checkAmount(amountInputId, inputDivId);
  }

  let totalPaymentsTitle = "TOTAL PAYMENTS"

  if ($('body').data('app-locale') == 'sw'){
    totalPaymentsTitle = 'JUMLA YA MALIPO'
  }

  $('#payment-options-div').append(
    `
    <div class="form-group"">
      <label class="col-xs-12" for="total">${totalPaymentsTitle}</label>
      <div class="col-xs-12 mb-1">
        <input id="payments-options-total"
          class="form-control" readonly="readonly"
          autocomplete="off" value=${numberWithCommas(calculatePaymentsTotal())}
        >
      </div>
    </div>`
  )
}

function addPaymentOption() {
  const selectOption = $('select[name="payment-options"] option:selected')
  const cashSourceId = selectOption.val()
  const cashSourceName = selectOption.data('cash-source-name')
  const cashSourceAmount = $('#payment-option-amount').val()
  const details = $('#payment-option-details').val()

  const paymentOptions = getPaymentOptionsStorage()

  if (isNaN(removeCommas(cashSourceAmount)) || allWhiteSpaces(cashSourceAmount)) {
    toastNotification('error', `Amount is invalid`);

    return
  }

  paymentOptions.push({
    cash_source_id: parseInt(cashSourceId),
    cash_source_name: cashSourceName,
    cash_source_amount: removeCommas(cashSourceAmount),
    details: details,
    timestamp: Date.now()
  })

  setPaymentOptionsStorage(paymentOptions)
  setPaymentOptionsInDom()
  $('#payment-option-amount').val('')
}

function removePaymentOption(timestamp) {
  const paymentOptions = getPaymentOptionsStorage()
  const existingOption = paymentOptions.filter(function (el) {
    return el.timestamp === timestamp
  })

  paymentOptions.splice(paymentOptions.indexOf(existingOption[0]), 1)

  setPaymentOptionsStorage(paymentOptions)
  setPaymentOptionsInDom()
}

function calculatePaymentsTotal() {
  const data = JSON.parse(localStorage.getItem(paymentOptionsKey()))

  if (data === null || data === undefined) {
    console.log('ERROR')
    return 0
  }

  let totalPayments = Object.values(data).reduce(function (accumulator, curValue) {
    return accumulator + parseFloat(curValue.cash_source_amount)
  }, 0)

  return totalPayments
}

function inputChangeHandler(element) {
  const elementValue = element.val()
  
  if (element.hasClass('add-payment-option-amount') &&
    (isNaN(removeCommas(elementValue)) || allWhiteSpaces(elementValue)) ){
    toastNotification('error', `Amount is invalid`);
    
    return
  }

  if (element.hasClass('payment-option-details')){
    const amountInput = $('#' + amountInputID(element.data('cash-source-id'),element.data('key')))
    amountInput.data('details', elementValue)
  }

  localStorage.removeItem(paymentOptionsKey())

  const paymentOptions = []

  $('.add-payment-option-amount').each(function(){
    const inputItem = $(this)
    const cashSourceId = inputItem.data('cash-source-id')
    const cashSourceName = inputItem.data('cash-source-name')
    const details = inputItem.data('details')
    const cashSourceAmount = inputItem.val()
    paymentOptions.push({
      cash_source_id: parseInt(cashSourceId),
      cash_source_name: cashSourceName,
      cash_source_amount: removeCommas(cashSourceAmount),
      details: details
    })
  })

  setPaymentOptionsStorage(paymentOptions)

  $('#payments-options-total').val(numberWithCommas(calculatePaymentsTotal()))
}

$(document).ready(function () {

  if ($('#payment-options-div').length > 0) {
    setInitialPaymentOptionsData()

    checkAmount('#payment-option-amount', '#payment-option-div')

    $('#add-payment-option').click(function () {
      addPaymentOption()
    })

    $('#payment-options-div').on('click', '.remove-payment-option', function () {
      const timestamp = $(this).data('timestamp')
      removePaymentOption(timestamp)
    })

    $('#payment-options-div').on('input', '.payment-option-input',function (e) {
      inputChangeHandler($(this))
    })

    $('select[name="payment-options"]').change(function () {
      $('#payment-option-amount').val('')
    })
  }

});